<style>
#addProjectedReceiverModal .v--modal-box.v--modal {
  min-height: 285px !important;
  min-width: 820px !important;
}
#addProjectedReceiverModal *:not(.v-icon) {
  font-size: 12px;
}
#addProjectedReceiverModal .icon {
  margin-right: 10px;
  margin-left: 10px;
}
#addProjectedReceiverModal .button__wrapper {
  padding-top: 5px;
  padding-bottom: 5px;
}
.row__border--bottom {
  border-bottom: 1px solid lightgrey;
}
</style>

<template>
  <Modal
    modalName="addProjectedReceiverModal"
    :title="editing ? 'Edycja projektowanego odbiorcy' : 'Tworzenie projektowanego odbiorcy'"
    :buttons="['save']"
    @opened="loadData"
    @closed="close"
    @saved="saveReceiver"
  >
    <div class="layouts__wrappers">
      <v-layout>
        <v-flex class="font--primary" xs5>
          <span v-if="editing">Wskaż nową lokalizację projektowanego odbiorcy</span>
          <span v-else>Wskaż lokalizację projektowanego odbiorcy</span>
          <span class="icon" @click="toggleBreak">
            <v-icon>add_location</v-icon>
          </span>
        </v-flex>
        <v-spacer/>
        <v-flex class="font--primary" xs5 style="text-align:right">
          <span v-if="editing">Wskaż nową lokalizację węzła nadrzędnego</span>
          <span v-else>Wskaż lokalizację węzła nadrzędnego</span>
          <span class="icon" @click="selectNewObject">
            <v-icon>add_location</v-icon>
          </span>
        </v-flex>
      </v-layout>
      <v-layout v-if="objects.length != 0">
        <v-flex>
          <v-list subheader style="width: 100%">
            <v-subheader class="font--primary">Zaznaczony obiekt</v-subheader>
            <v-list-tile
              v-for="(object, index) in objects"
              :item="object"
              :key="object.object_id"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content>
                <v-list-tile-title
                  class="font--primary"
                >Obiekt {{object.object_table}} - {{object.object_id}}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon
                  depressed
                  fab
                  class="hydrant__icon"
                  id="btn__hydrant--remove"
                  @click="removeObject(object, index)"
                  title="Usuń obiekt"
                >delete</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-select
            v-model="selectedCurve"
            :items="curves"
            item-text="description"
            item-value="curve_id"
            label="Wzorzec rozbioru"
            :rules="[rules.required]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs5>
          <v-text-field height="16" label="Adres" v-model="address" :rules="[rules.required]"></v-text-field>
        </v-flex>
        <v-spacer/>
        <v-flex xs5>
          <v-text-field
            height="16"
            label="Przewidywany rozbiór"
            @keypress="isNumber($event)"
            v-model="demand"
            :rules="[rules.required]"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-select
            v-model="selectedUnit"
            :items="units"
            label="Jednostka"
            :rules="[rules.required]"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-text-field height="16" label="Opis" v-model="description"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="editing">
        <v-flex>
          <v-btn color="error" @click="removeReceiver">Usuń projektowanego odbiorcę</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import each from "lodash/each";
mixin(_, {
  each
});

export default {
  data: () => ({
    editing: false,
    editingId: undefined,
    locationChanged: false,
    pointCoords: undefined,
    isClickable: false,
    address: undefined,
    demand: undefined,
    description: undefined,
    curves: [],
    objects: [],
    selectedCurve: [],
    selectedCurveId: undefined,
    selectedUnit: [],
    units: ["m3/h", "m3/d", "m3/mc"],
    rules: {
      required: value => !!value || "Pole wymagane"
    }
  }),
  components: {
    Modal
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    },
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    }
  },
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    loadData() {
      this.$store.dispatch("getCurvesForModelWat").then(r => {
        if (r) {
          this.curves = r.curves;
          if (this.editing) {
            for (let curve of this.curves) {
              if (curve.id == this.selectedCurveId) {
                this.selectedCurve = curve;
                break;
              }
            }
          }
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    removeReceiver() {
      let id = this.editingId;
      const self = this;
      this.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Usuwanie projektowanego odbiorcy",
        text: "Czy na pewno chcesz usunąć projektowanego odbiorcę?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store
                .dispatch("deleteVirtualRecipient", id)
                .then(success => {
                  if (success) {
                    self.$root.$emit("removeVirtualRecipientPoint", id);
                    self.$root.$emit(
                      "showSnackbar",
                      "success",
                      "Pomyślnie usunięto projektowanego odbiorcę"
                    );
                    this.close();
                  } else {
                    self.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania projektowanego odbiorcy wystąpił błąd"
                    );
                  }
                });
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    toggleBreak() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wskazać lokalizację projektowanego odbiorcy"
      );
      this.isClickable = true;
      this.locationChanged = true;
      this.$root.$emit("removeMarker");
      this.map.getViewport().style.cursor = "crosshair";
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    removeObject(object, index) {
      this.objects.splice(index, 1);
    },
    selectNewObject(isStart) {
      const self = this;
      if (!this.layersInstance["junctions"].getVisible()) {
        self.$root.$emit(
          "showSnackbar",
          "orange",
          "Włącz widoczność warstwy aby móc wybrać element"
        );
        return;
      }
      if (this.objects.length == 1) {
        self.$root.$emit(
          "showSnackbar",
          "red",
          " W celu dodania nowego węzła, usuń obecnie wybrany."
        );
        return;
      }
      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać węzeł"
      );
      self.map.getViewport().style.cursor = "crosshair";
      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          _.each(featuresLayer.features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();

            if (_.some(self.objects, object => object.object_id === id)) {
              return; //duplicat
            }

            self.objects.push({
              object_id: feature.getId(),
              object_table: featuresLayer.layer.get("type")
            });
          });
        });
        self.$forceUpdate();
        self.map.getViewport().style.cursor = "";
      });
      self.$root.$emit("enableSelectionElement", {
        layers: ["junctions"],
        nearest: true
      });
    },
    saveReceiver() {
      if (!this.pointCoords) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Wskaż lokalizację projektowanego odbiorcy"
        );
        return;
      }
      if (this.selectedCurve.length == 0) {
        this.$root.$emit("showSnackbar", "red", "Wybierz wzorzec rozbioru");
        return;
      }
      if (this.selectedUnit.length == 0) {
        this.$root.$emit("showSnackbar", "red", "Wybierz jednostkę");
        return;
      }
      if (!this.address) {
        this.$root.$emit("showSnackbar", "red", "Podaj adres");
        return;
      }
      if (!this.description) {
        this.$root.$emit("showSnackbar", "red", "Podaj opis");
        return;
      }
      if (!this.demand) {
        this.$root.$emit("showSnackbar", "red", "Podaj przewidywany rozbiór");
        return;
      }
      if (this.objects.length == 0) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Wskaż lokalizację węzła nadrzędnego"
        );
        return;
      }
      if (this.objects.length > 1) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Wskaż dokładnie jeden węzeł nadrzędny"
        );
        return;
      }

      if (this.editing) {
        let payload = {
          oid: this.editingId,
          body: {
            address: this.address,
            demand: this.demand,
            description: this.description,
            geom: {
              coordinates: this.pointCoords,
              type: "Point"
            },
            parent_junction: this.objects[0].object_id,
            pattern: this.selectedCurve.id,
            unit: this.selectedUnit
          }
        };
        this.$store.dispatch("editVirtualRecipient", payload).then(r => {
          if (r) {
            this.$root.$emit("refreshProjectedRecipients");
            if (this.locationChanged) {
              this.$root.$emit("removeVirtualRecipientPoint", this.editingId);
              this.$root.$emit("addVirtualRecipientPoint", [
                payload.body,
                this.pointCoords,
                r.data.updated
              ]);
            }
            this.close();
          } else {
            this.$root.$emit("showSnackbar", "red", `${r}`);
          }
        });
      } else {
        let payload = {
          address: this.address,
          demand: this.demand,
          description: this.description,
          geom: {
            coordinates: this.pointCoords,
            type: "Point"
          },
          parent_junction: this.objects[0].object_id,
          pattern: this.selectedCurve.id,
          unit: this.selectedUnit
        };

        this.$store.dispatch("addVirtualRecipient", payload).then(r => {
          if (r) {
            this.$root.$emit("refreshProjectedRecipients");
            this.$root.$emit("addVirtualRecipientPoint", [
              payload,
              this.pointCoords,
              r.data.inserted
            ]);
            this.close();
          } else {
            this.$root.$emit("showSnackbar", "red", `${r}`);
          }
        });
      }
    },
    close() {
      this.$root.$emit("removeMarker");
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.$modal.hide("addProjectedReceiverModal");
      this.pointCoords = undefined;
      this.isClickable = false;
      this.address = undefined;
      this.demand = undefined;
      this.description = undefined;
      this.selectedCurve = [];
      this.selectedUnit = [];
      this.objects = [];
      this.editing = false;
      this.editingId = undefined;
      this.locationChanged = false;
    },
    switchMode(data) {
      if (!Array.isArray(data)) {
        this.editingId = data.id;
        this.address = data.properties.address;
        this.demand = data.properties.demand;
        this.description = data.properties.description;
        this.pointCoords = data.geometry.coordinates;
        this.selectedCurveId = data.properties.pattern;
        this.selectedUnit = data.properties.unit;
        this.objects = [
          {
            object_id: data.properties.parent_junction,
            object_table: "junctions"
          }
        ];
        this.editing = true;
      } else {
        this.editingId = data[2];
        this.address = data[0].address;
        this.demand = data[0].demand;
        this.description = data[0].description;
        this.pointCoords = data[1];
        this.selectedCurveId = data[0].pattern;
        this.selectedUnit = data[0].unit;
        this.objects = [
          {
            object_id: data[0].parent_junction,
            object_table: "junctions"
          }
        ];
        this.editing = true;
      }
    }
  },
  mounted() {
    let unwatch = this.$watch("map", map => {
      this.map.on("singleclick", evt => {
        if (this.isClickable) {
          this.pointCoords = evt.coordinate;
          this.$root.$emit("addMarker", evt.coordinate);
          this.isClickable = false;
          this.map.getViewport().style.cursor = "";
        }
      });
      unwatch();
    });

    this.$root.$on("editProjectedReceiver", this.switchMode);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/AddProjectedReceiver.vue